import React from 'react';

import setaIconAdd from './seta-azul-add.png';
import setaIconSub from './seta-azul-sub.png';
import setaIconLeft from './seta-branco-left.png';
import setaIconRight from './seta-branco-right.png';

export const SetaIconAdd = () =>
  <img src={setaIconAdd} alt="add" />;

export const SetaIconSub = () =>
  <img src={setaIconSub} alt="sub" />;

export const SetaIconLeft = props =>
  <img src={setaIconLeft} alt="left" {...props} />;

export const SetaIconRight = props =>
  <img src={setaIconRight} alt="right" {...props} />;
